import { breakpoint } from '../../utils/store';

export default class ServicesPreview {
    constructor() {
        this.section = document.querySelector('section.services-preview');

        this.services_preview = {
            toggler: document.querySelectorAll('section.services-preview .toggler'),
            item: document.querySelectorAll('section.services-preview .service-item'),
        };
    }

    init() {
        this.toggle();
        if(!Sniff.features.mobile){ this.heightFix(); }
    }
    
    toggle = () => {
        this.services_preview.toggler.forEach((toggler) => {
            toggler.addEventListener('click', (e) => {
                this.services_preview.item.forEach((item)=>{
                    item.classList.remove('active');
                });
                e.target.parentNode.classList.add('active');
            });
        });
    }

    heightFix = () => {
        console.log(this.section.offsetHeight);
        
        var minHeight = 0;

        // Re-write variable (Maybe it's necessary only half of the first '.description' Height)
        var minHeight = this.section.offsetHeight + (this.services_preview.toggler[0].parentNode.querySelector('.description').offsetHeight / 2);

        this.section.style.minHeight = minHeight + 'px';
    }
}
